window.archiveReportagesPage = function(reportagesData = []) {
    return {
        currentPage: 1,
        perPage: 12,
        reportages: reportagesData,

        get paginatedReportages() {
            const start = (this.currentPage - 1) * this.perPage;
            return this.reportages.slice(start, start + this.perPage);
        },

        get totalPages() {
            return Math.ceil(this.reportages.length / this.perPage);
        },

        get visiblePages() {
            const total = this.totalPages;
            const current = this.currentPage;
            if (total <= 7) {
                return Array.from({ length: total }, (_, i) => i + 1);
            }
            const pages = [];
            let ellipsisCount = 0;
            for (let i = 1; i <= total; i++) {
                if (i === 1 || i === total || (i >= current - 1 && i <= current + 1)) {
                    pages.push(i);
                } else if (pages[pages.length - 1] > 0) {
                    pages.push(-(++ellipsisCount));
                }
            }
            return pages;
        },

        goToPage(page) {
            if (page < 1 || page > this.totalPages) return;
            this.currentPage = page;
            const el = document.querySelector('.archive-reportages');
            if (el) {
                window.scrollTo({ top: el.offsetTop - 20, behavior: 'smooth' });
            }
        }
    }
}
